export default "__VITE_ASSET__a0d8e34d__"